import React, {FC} from 'react'

const ToggleHelpDrawer: FC = () => (
  <></>
)

export {ToggleHelpDrawer}
